import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getUsersAsOptions } from '../../services/companyUsers';
import { onQuerySuccess } from '../../utils/queryResponse';
import FormSelect from '../forms/formSelect';

const ParticipantsSelect = ({ value, isMulti, ...rest }) => {

    const [options, setOptions] = useState([])

    const { data, isLoading } = useQuery(['users-option'], getUsersAsOptions)

    useEffect(() => {
        onQuerySuccess(data, (result) => {
            if (result.length > 0) {
                setOptions(result.map(d => ({
                    value: d.id, label: d.fullName, roles: d.roles
                })))
            }
        })
    }, [data])

    return (
        <FormSelect isMulti={isMulti} {...rest}
            value={
                isMulti ? (value && options.filter(x => value.includes(x.value)).map(val => ({ value: val.value, label: val.label }))) :
                    (options.find(opt => opt.value === value) || null)
            }
            options={options}
            isLoading={isLoading}
        />
    )
}

export default ParticipantsSelect